module.exports = __webpack_public_path__ + "static/media/donation-bg.489c64ef.jpg";